import { useBucket } from '@mc/experiments-react'

import { CM_HERO_IS_A_TRAILER_FLAG } from './Experiment'

export const useCMTrailerHeroEnabled = () =>
  useBucket(CM_HERO_IS_A_TRAILER_FLAG) === 'variant_1'
